import i18n from "utils/I18n";
import { createAction } from 'utils';
import { inMiniProgram, requestMiniProgramLocation } from "utils/WeChatUtil"

function getLocationSuccess({ dispatch, data }) {
    dispatch && dispatch(
        createAction('campaignDetail/verifyGPS')(data)
    );
}

function getLocationDeniedInWeChat() {
    window.wx.miniProgram.navigateTo({ url: `/pages/location/location` })
}

function getLocationFailed({ dispatch }) {
    dispatch && dispatch(createAction("navBars/updateState")(
        {
            toastShowing: {
                value: true,
                content: i18n.t("campaignDetail:invalidGPSLocation"),
            },
        }
    ))
}

function getGeo({
    dispatch,
    data,
    geoTimeout,
    noFailHandle
}) {
    navigator.geolocation.getCurrentPosition(
        (position) => {
            getLocationSuccess({ dispatch, data: { ...data, latitude: position.coords.latitude, longitude: position.coords.longitude } })
        },
        (error) => {
            if (noFailHandle) {
                return
            }
            switch (error.code) {
                case error.PERMISSION_DENIED:
                case error.POSITION_UNAVAILABLE:
                case error.TIMEOUT:
                default:
                    getLocationFailed({ dispatch })
            }
        },
        geoTimeout || {}
    );
}

export function requestLocation({
    dispatch = null,
    data = {},
    geoTimeout = {},
    noFailHandle = false,
    success = getLocationSuccess,
}) {
    const isInMiniProgram = inMiniProgram()
    if (isInMiniProgram) {
        requestMiniProgramLocation({
            onSuccess: (res) => {
                success({ dispatch, data: { ...data, latitude: parseFloat(res.latitude), longitude: parseFloat(res.longitude) } })
            },
            onFailed: (errMsg) => {
                if (noFailHandle) {
                    return
                }
                if (errMsg?.includes("fail")) {
                    getLocationDeniedInWeChat()
                    return
                }
                getLocationFailed({ dispatch })
            },
        })
        return
    }
    getGeo({
        dispatch,
        data,
        geoTimeout,
        noFailHandle,
    })
}

export const getDistanceFromLatitudeAndLongitude = (
    useLatitude,
    useLongitude,
    targetLatitude,
    targetLongitude
) => {
    if (!useLatitude || !useLongitude || !targetLatitude || !targetLongitude) {
        return '';
    }
    if (useLatitude === targetLatitude && useLongitude === targetLongitude) {
        return "0m";
    }
    const radlat1 = (Math.PI * useLatitude) / 180;
    const radlat2 = (Math.PI * targetLatitude) / 180;
    const theta = useLongitude - targetLongitude;
    const radtheta = (Math.PI * theta) / 180;
    let dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    const finalDist = dist * 1.609344;
    if (finalDist > 1) {
        return `${Math.ceil(finalDist)}km`;
    }
    return `${Math.ceil(finalDist * 1000)}m`;
};